import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import type { UsePracticeRevenueResult } from '@hooks/dashboard/usePracticeRevenue'
import {
  financeTrendLine,
  HYGIENE_PLACEHOLDER,
} from '@utils/dashboardFinance.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { FinanceMetricTilesRow } from '../../FinanceMetricTiles.component'

type PracticeRevenueOverviewCardProps = {
  titleHref: string
  practiceRevenue: UsePracticeRevenueResult
}

export function PracticeRevenueOverviewCard({
  titleHref,
  practiceRevenue,
}: PracticeRevenueOverviewCardProps): React.ReactElement {
  const { loading, cards, range, hasData, hasPayload } = practiceRevenue
  const isEmpty = shouldShowDashboardSectionEmpty(loading, hasData)
  const pending = isDashboardSectionPending(loading, hasPayload)

  return (
    <DashboardSectionCard
      title="Practice revenue overview"
      titleHref={titleHref}
      loading={pending}
      skeleton={{ metrics: 4, block: 'none' }}
      isEmpty={isEmpty}
    >
      <FinanceMetricTilesRow
        columns={4}
        metrics={cards.map((c) => ({
          id: c.leftLabel,
          leftLabel: c.leftLabel,
          rightLabel: c.rightLabel,
          value: loading ? HYGIENE_PLACEHOLDER : c.value,
          footer: loading
            ? undefined
            : financeTrendLine(range, c.footerPct, c.footerAmt),
          footerTrend: loading ? undefined : c.footerUp ? 'up' : 'down',
        }))}
      />
    </DashboardSectionCard>
  )
}
